<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <div class="steps-bar">
            <div
              v-for="(step, index) in steps"
              :key="index"
              :class="{
                'steps-bar__item--last': index >= steps - 1,
                'steps-bar__item--active': currentStep >= index + 1,
              }"
              class="steps-bar__item"
            >
              <div class="steps-bar__item-dot">{{ index + 1 }}</div>
              <div class="steps-bar__item-line"></div>
            </div>
          </div>

          <div v-if="currentStep === 1" class="step">
            <FormSection title="1. Choose Your Gift">
              <div class="multiple__payoptions">
                <OuGivingPaymentOptions addMonthly addSplit />
              </div>
              <br />
              <div>
                <p><em>Please select your tax-deductible gift amount below</em></p>
                <AmountSelector />
                <ErrorLabel field="amount" />
              </div>
            </FormSection>
            <FormSection v-if="form.amount">
              <TransactionFee />
            </FormSection>

            <div class="step__btn-wrapper" v-if="form.amount && Number(form.amount) > 0">
              <div class="btn btn--negative" @click="currentStep = 2">Next</div>
            </div>
          </div>

          <div v-if="currentStep === 2" class="step step--lg">
            <FormSection title="2. Choose Charities">
              <div class="charity__wrapper">
                <div class="charity__group">
                  <div
                    class="charity__col"
                    v-for="(char, index) in charities"
                    :key="index"
                  >
                    <div class="charity__img" v-if="char.img">
                      <img :src="char.img" :alt="`${char.name} logo`" />
                    </div>
                    <div class="charity__info">
                      <div class="charity__icon">
                        <span v-if="char.amount" class="charity__icon--rm"
                          ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path
                              d="M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
                            /></svg
                        ></span>
                        <span class="charity__icon--add" v-else>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path
                              d="M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
                            />
                          </svg>
                        </span>
                      </div>

                      <div class="charity__left">
                        <div class="charity__title" v-html="char.name"></div>
                        <div
                          class="charity__excerpt"
                          v-html="char.desc"
                          v-if="!char.amount"
                        ></div>
                      </div>

                      <div class="charity__right">
                        <div class="charity__input" v-if="char.amount">
                          <input
                            type="text"
                            :value="char.amount"
                            @change="setAmount($event.target.value, char)"
                          />
                        </div>

                        <div class="charity__action">
                          <span
                            v-if="char.amount"
                            class="charity__action--rm"
                            @click="addOrRemoveCharity(char)"
                            >Remove</span
                          >
                          <span
                            class="charity__action--add"
                            v-else
                            @click="addOrRemoveCharity(char)"
                            >ADD</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="charity__cart" v-if="selected">
                  <p class="charity__total">
                    {{ charities.filter((c) => c.amount).length }} charities selected.
                  </p>
                  <ul>
                    <li v-for="(selc, index) in charities" :key="index">
                      <div class="charity__list" v-if="selc.amount">
                        <div class="charity__list__title" v-html="selc.name"></div>
                        <div class="charity__list__amount">{{ selc.amount }}</div>
                        <div
                          class="charity__list__action"
                          @click="addOrRemoveCharity(selc)"
                        >
                          <svg
                            width="10"
                            height="10"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.375 1.375L12.625 12.625"
                              stroke="#A0A8B6"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                            <path
                              d="M1.375 12.625L12.625 1.375"
                              stroke="#A0A8B6"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </FormSection>
            <div class="step__btn-wrapper">
              <div class="btn btn--prev" @click="currentStep = 1">Previous</div>
              <div class="btn btn--negative" @click="currentStep = 3">Next</div>
            </div>
          </div>

          <div v-if="currentStep === 3" class="step">
            <FormSection title="3. Personal Information">
              <FormRow inline>
                <FormCol field="title" :flex="1" />
                <FormCol field="firstName" :flex="2" />
                <FormCol field="lastName" :flex="2" />
              </FormRow>
              <FormRow inline>
                <FormCol field="email" />
              </FormRow>
              <DonorAddress />
              <FormCol field="phone" />
            </FormSection>
            <div class="step__btn-wrapper">
              <div class="btn btn--prev" @click="currentStep = 2">Previous</div>
              <div class="btn btn--negative" @click="currentStep = 4">Next</div>
            </div>
          </div>
          <div v-if="currentStep === 4" class="step">
            <div class="total__summary" v-if="selected">
              <div class="total__summary__total">
                {{ charities.filter((c) => c.amount).length }} charities selected.
              </div>
              <ul class="total__summary__list">
                <li v-for="(selc, index) in charities" :key="index">
                  <div class="tcharity__list" v-if="selc.amount">
                    <div class="tcharity__list__title" v-html="selc.name"></div>
                    <div class="tcharity__list__amount">${{ selc.amount }}</div>
                  </div>
                </li>
              </ul>
            </div>
            <FormSection title="4. Payment Information" last>
              <FormCol field="card" :showLabel="false" />
            </FormSection>
            <FormSection last> </FormSection>
            <PaymentButton showAmount btnText="Donate" />
            <br />
            <FormRow>
              <NewsletterSubscribe
                text="Sign me up for the OU's weekly Shabbat Shalom newsletter"
              />
            </FormRow>
          </div>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { usePaymentForm } from "~/shared/use-payment-form";
import { defineComponent, ref, watch } from "vue";
import sum from "lodash/sum";

export default defineComponent({
  setup() {
    const { form, submit, setValue } = usePaymentForm();

    const state = ref(false);
    const selected = ref(false);

    const stateToggle = (char: any) => {
      if (char.amount) char.amount = 0;
      else {
        const amountLeft =
          Number(form.value.amount || 0) - sum(charities.value.map((x) => x.amount || 0));

        char.amount = amountLeft;
      }

      selected.value = true;
    };

    const charities = ref([
      {
        name: "Torah Initiatives",
        desc: "Enriching lives through accessible Torah",
        img:
          "https://res.cloudinary.com/orthodox-union/image/upload/v1675273357/Logos/benefacoters%20logos/torahinitiave.png",
        amount: 0,
        department: "OU_Torah",
        campaign: "General Donation",
        subCampaign: null,
      },
      {
        name: "Community Projects & Partnerships",
        desc: "Working together for the community",
        img:
          "https://res.cloudinary.com/orthodox-union/image/upload/v1675273357/Logos/benefacoters%20logos/ou-blue.png",
        amount: 0,
        department: "CommunityProjectsAndPartnerships",
        campaign: "General Donation",
        subCampaign: null,
      },
      {
        name: "Teach Coalition",
        desc: "Fighting for Jewish schools to receive fair government funding",
        img:
          "https://res.cloudinary.com/orthodox-union/image/upload/v1675273680/Logos/benefacoters%20logos/teachlogo.png",
        amount: 0,
        department: "TeachCoalition",
        campaign: "General Donation",
        subCampaign: null,
      },
      {
        name: "OU Israel",
        desc: "Outreach to at-risk youth, support for olim and soldiers",
        img:
          "https://res.cloudinary.com/orthodox-union/image/upload/v1675273356/Logos/benefacoters%20logos/ouisrael.png",
        amount: 0,
        department: "OUIsrael",
        campaign: "General Donation",
        subCampaign: null,
      },
      {
        name: "NCSY",
        desc: "Lifechanging teen empowerment and inspiration programs",
        img:
          "https://res.cloudinary.com/orthodox-union/image/upload/v1675273356/Logos/benefacoters%20logos/ncsy.png",
        amount: 0,
        department: "NCSY",
        campaign: "General Donation",
        subCampaign: null,
      },
      {
        name: "OU-JLIC",
        desc: "Supporting Jewish life on college campuses",
        img:
          "https://res.cloudinary.com/orthodox-union/image/upload/v1675273358/Logos/benefacoters%20logos/jlic.png",
        amount: 0,
        department: "JLIC",
        campaign: "General Donation",
        subCampaign: null,
      },
      {
        name: "Women's Initiative",
        desc: "Torah, leadership, and community engagement for women",
        img:
          "https://res.cloudinary.com/orthodox-union/image/upload/v1675273357/Logos/benefacoters%20logos/womens.png",
        amount: 0,
        department: "WomensInitative",
        campaign: "General Donation",
        subCampaign: null,
      },
      {
        name: "Yachad",
        desc: "A place where everyone of all abilities belongs",
        img:
          "https://res.cloudinary.com/orthodox-union/image/upload/v1675273358/Logos/benefacoters%20logos/yachad.png",
        amount: 0,
        department: "Yachad",
        campaign: "General Donation",
        subCampaign: null,
      },
    ]);

    watch(
      charities,
      (charities) => {
        charities
          .filter((x) => x.amount > 0)
          .forEach((char, i) => {
            // no idea :shrug:
            //@ts-ignore
            setValue(`applications.${i}.amount`, char.amount);
            //@ts-ignore
            setValue(`applications.${i}.department`, char.department || null);
            //@ts-ignore
            setValue(`applications.${i}.campaign`, char.campaign || null);
            //@ts-ignore
            setValue(`applications.${i}.subCampaign`, char.subCampaign || null);
          });
      },
      {
        deep: true,
      }
    );

    return {
      form,
      steps: 4,
      currentStep: 1,
      finished: false,
      charities,
      submit,
      selected,
      state,
      addOrRemoveCharity: stateToggle,
      setAmount(amount: string, char: any) {
        char.amount = +amount;

        const total = sum(charities.value.map((x) => x.amount || 0));

        if (total > +form.value.amount!) {
          char.amount -= total - +form.value.amount!;
        }
      },
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}

::v-deep .form-container.ou-donation-form {
  max-width: 900px;
}
::v-deep .ou-donation-form {
  line-height: 1.4;
  h2 {
    color: #15329d;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 15px;
  }

  input[type="email"],
  input[type="number"],
  input[type="password"],
  input[type="tel"],
  input[type="text"],
  textarea,
  select {
    font-size: 14px;
  }
  input[type="tel"] {
    height: 42px;
  }
}
::v-deep .frequency {
  display: flex;
  justify-content: space-between;

  .styled-radio-container--ou-donation.styled-radio-contain {
    margin: 0px 0px 0px auto;
    justify-content: flex-end;

    .radio-part {
      margin-bottom: 0px;
    }
    input[type="radio"] {
      position: relative;
    }
  }
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
input[type="checkbox"] {
  margin-right: 5px;
}
::v-deep .radio-part {
  min-width: 31.33333% !important;
  max-width: 31.33333% !important;
  &:nth-child(3n) {
    padding-right: 0 !important;
  }
}
::v-deep .amount_other__wrapper {
  max-width: 29.666% !important;
}
::v-deep div[data-amount="12"] {
  order: 1;
  margin-left: 2%;
  padding-right: 0 !important;
}
::v-deep
  .styled-radio--ou-donation.styled-radio
  input[type="radio"]
  + label[data-amount="12"] {
  padding: 8px 0 !important;
  display: block !important;
  &:after {
    content: "college student special";
    font-size: 11px;
    width: 100%;
    display: block;
    color: #666;
    margin-top: 3px;
  }
}

// ::v-deep .styled-radio--ou-donation.styled-radio input[type='radio']:not(:checked) + label[data-amount="100"] {
//   background: #eee7fd;
// }

::v-deep .styled-radio--ou-donation.styled-radio input[type="radio"]:not(:checked) + label {
  background: #e5e8e9;
  color: #222;
}
::v-deep .styled-radio--ou-donation.styled-radio input[type="radio"]:checked + label {
  background: #15329d;
  color: white;
}
::v-deep .styled-radio--ou-donation.styled-radio .amount_other__wrapper {
  min-width: 31.33333% !important;
  max-width: 31.33333% !important;
}
::v-deep .ou-donation-form .ou-donation-btn {
  background: #15329d;
  color: white;
  font-size: 20px;
  height: 50px;
  border-color: white;
}
::v-deep .thank-you-container .ou-donation-btn {
  background: #15329d;
  color: white;
  font-size: 20px;
  height: 50px;
  border-color: white;
}

.donate__note {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid rgb(214, 233, 198);
  border-radius: 4px;
  color: rgb(60, 118, 61);
  background-color: rgb(223, 240, 216);
}

.membership {
  font-size: 14px;
  margin: 15px 0;
  background-color: #d9edf7;
  border-color: #bce8f1;
  color: #31708f;
  padding: 11px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 0px solid #000000;
  p {
    margin: 0;
  }
  a {
    color: #2403ee;
    display: block;
    font-weight: bold;
  }
}

.charity__group {
  // height: 400px;
  margin: 15px 0;
  max-width: 700px;
  width: 100%;
  // border: 1px solid #ccc;
  // overflow: auto;
  padding: 10px 15px;
  background: white;
  gap: 20px;
  color: #667085;
}
.charity__wrapper {
  display: flex;
  @media (max-width: 720px) {
    flex-flow: column;
  }
}
.charity__left {
  flex: 1;
}
.charity__col {
  display: flex;
  // align-items: center;
  cursor: pointer;
  border-radius: 8px;
  position: relative;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
  &:hover {
    background-color: #fafafa;
  }

  @media (max-width: 720px) {
    flex-flow: column;
  }
}
.charity__img {
  flex: 0 1 100px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  background-size: cover;
  background-position: center;
  @media (min-width: 720px) {
    min-height: 75px;
  }
  img {
    height: 100px;
    width: auto;
    text-align: center;
    margin: 0 auto;
    @media (min-width: 720px) {
      object-position: center;
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }
}

.charity__info {
  flex: 1;
  padding: 8px 10px;
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: space-between;
  .charity__right {
    margin-left: auto;
    align-self: flex-end;
  }

  .charity__icon {
    position: absolute;
    top: -5px;
    right: 0px;
    display: none;
    z-index: 999;
    background: white;
    .charity__icon--rm {
      svg {
        width: 25px;
        fill: black;
        padding: 5px;
        border-radius: 50%;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
          0 8px 10px -6px rgba(0, 0, 0, 0.1);
      }
    }
    .charity__icon--add {
      svg {
        width: 25px;
        fill: #e5e7eb;
        padding: 5px;
        border-radius: 50%;
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
      }
    }
  }
}
.charity__title {
  color: black;
  font-weight: 600;
  padding-bottom: 5px;
  font-size: 15px;
  line-height: normal;
}
.charity__excerpt {
  overflow: hidden;
  color: #9ca3af;
  font-size: 13px;
  line-height: 1.3;
  max-width: calc(100% - 76px);
}

.charity__input {
  display: flex;
  justify-content: flex-end;
  input {
    height: 39px;
    max-width: 60px;
    border-color: #15329d;
    // border: 1px solid #d0d5dd;
    box-sizing: border-box;
    box-shadow: 0 1px 2px #1018280d;
    border-radius: 8px;
  }
}
.charity__action {
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  margin-top: auto;
  font-weight: 600;
  color: white;

  span {
    background: #15329d;
    display: block;
    line-height: 1.4;
    font-size: 14px;
    padding: 5px 7px;
    position: relative;
    border-radius: 9999px;

    &.charity__action--rm {
      background: inherit;
      // color: #15329d;
      position: relative;
      margin-top: 5px;
      padding-right: 0px;
      color: #9ca3af;
      border-radius: 0px;
      text-transform: capitalize;
      text-decoration: underline;
    }
  }
}

.steps-bar {
  display: flex;
  max-width: 350px;
  margin: 50px auto 35px;
  justify-content: space-between;
}
.steps-bar__item {
  display: flex;
  position: relative;
  flex-grow: 1;
  &.steps-bar__item--last {
    flex-grow: 0;
  }
  &.steps-bar__item--active {
    .steps-bar__item-dot {
      background: #15329d;
      color: #ffffff;
      border: 1px solid #15329d;
    }
    .steps-bar__item-line {
      background: #15329d;
    }
  }
}

.steps-bar__item-dot {
  background: #ececec;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  min-width: 32px;
  font-size: 12px;
  text-align: center;
  color: #15329d;
  border: 1px solid #cecece;
  line-height: 33px;
}
.steps-bar__item-line {
  height: 2px;
  background: #e1e1e1;
  flex-grow: 1;
  top: 16px;
  position: relative;
}

.step__btn-wrapper {
  display: flex;
  // max-width: 330px;
  padding-top: 24px;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: space-between;
}

.step {
  max-width: 700px;
  margin: 0 auto;

  &.step--lg {
    max-width: 100%;
  }
}
.btn {
  padding: 13px 35px 11px 35px;
  border: 1px solid #15329d;
  color: #15329d;
  font-size: 16px;
  display: inline-block;
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;
  text-decoration: none;
  line-height: 1;
  margin-bottom: 15px;
  padding-right: 25px;
  padding-left: 25px;
  margin-left: auto;

  &.btn--negative {
    background: #15329d;
    color: white;
  }
  &.btn.btn--disabled {
    opacity: 1;
    filter: grayscale(100%);
    background: #fafafa;
    color: #b9b9b9;
    border-color: #cfcfcf;
  }
  &.btn--prev {
    margin-left: 0px;
  }
}

.charity__cart {
  @media (min-width: 720px) {
    width: 40%;
    margin-left: 2%;
  }
  ul {
    padding: 0px;
    margin: 0px;
    position: relative;
    li {
      position: relative;

      .charity__list {
        width: 100%;
        justify-content: space-between;
        align-items: center;
        overflow: auto;
        padding: 10px;
        margin-bottom: 19px;
        gap: 5px;
        display: flex;
        border-radius: 0.5rem;
        border-width: 1px;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
      }
    }
  }
}
.charity__list__action {
  position: absolute;
  top: -15px;
  border-radius: 50%;
  // border: 1px solid gray;
  width: 18px;
  height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  right: -5px;
  padding: 5px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  &:hover {
    background-color: #fafafa;
    svg path {
      stroke: red;
    }
  }
}
.charity__list__title {
  color: #15329d;
  font-weight: bold;
  font-size: 14px;
  flex: 1;
}
.charity__list__amount {
  color: black;
  font-weight: 500;
  margin: 0 auto;
}
p.charity__total {
  color: #9ca3af;
  text-align: center;
  margin-bottom: 14px;
}

.total__summary {
  background: #fafafa;
  padding: 10px 15px;
  max-width: 300px;
  margin: 0 auto 24px;
}
.total__summary__total {
  color: black;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
  font-size: 18px;
}
ul.total__summary__list {
  margin: 0px auto;
  display: flex;
  padding: 0px 0px 2px;
  justify-content: center;
  flex-flow: column;

  li {
    padding: 0px 0px;
  }
}
.tcharity__list {
  display: flex;
  font-weight: 500;
  line-height: 1.4;
  text-transform: capitalize;
  color: #232e38;
  gap: 10px;
  margin-bottom: 2px;
  padding-bottom: 5px;
  justify-content: space-between;
}
.tcharity__list__title {
  font-weight: 400;
  font-style: normal;
  font-size: 15px;
  color: #4b5866;
}
::v-deep .multiple__payoptions {
  .radio__label {
    flex-flow: wrap;
  }
  .monthly-note {
    width: 100%;
  }
}
</style>
